"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const amex_js_1 = require("./amex.js");
const diners_js_1 = require("./diners.js");
const discover_js_1 = require("./discover.js");
const hipercard_js_1 = require("./hipercard.js");
const jcb_js_1 = require("./jcb.js");
const unionpay_js_1 = require("./unionpay.js");
const mastercard_js_1 = require("./mastercard.js");
const unknown_js_1 = require("./unknown.js");
const visa_js_1 = require("./visa.js");
exports.default = {
    amex: amex_js_1.default,
    diners: diners_js_1.default,
    discover: discover_js_1.default,
    hipercard: hipercard_js_1.default,
    jcb: jcb_js_1.default,
    unionpay: unionpay_js_1.default,
    mastercard: mastercard_js_1.default,
    unknown: unknown_js_1.default,
    visa: visa_js_1.default,
};
